export const SEARCH_PRODUCT_ON_LOAD = 'productMngt/on_load';
export const searchProductOnLoad = () => ({
  type: SEARCH_PRODUCT_ON_LOAD
});


export const SEARCH_PRODUCT_ON_LOAD_SUCCESS = 'productMngt/on_load_success';
export const searchProductOnLoadSuccess = () => ({
  type: SEARCH_PRODUCT_ON_LOAD_SUCCESS
});

export const SEARCH_PRODUCT_ON_RESET = 'productMngt/on_reset';
export const searchProductOnReset = () => ({
  type: SEARCH_PRODUCT_ON_RESET
});

export const SEARCH_PRODUCT_FILTER = 'productMngt/filter';
export const searchProductFilter = data => ({
  type: SEARCH_PRODUCT_FILTER,
  payload: data
});


export const SEARCH_PRODUCT_FILTER_SUCCESS = 'productMngt/filter_success';
export const searchProductFilterSuccess = data => ({
  type: SEARCH_PRODUCT_FILTER_SUCCESS,
  payload: data
});

export const TIER_FEE_ON_LOAD = 'productMngt/get_tier_fee';
export const getTierFeeById = (serviceId) => ({
  type: TIER_FEE_ON_LOAD,
  payload: serviceId
});

export const TIER_FEE_ON_SUCCESS = 'productMngt/tier_fee_on_success';
export const tierFeeOnSuccess = (data) => ({
  type: TIER_FEE_ON_SUCCESS,
  payload: data
});

export const TIER_FEE_ON_FAILED = 'productMngt/tier_fee_on_failed';
export const tierFeeOnFailed = (error) => ({
  type: TIER_FEE_ON_FAILED,
  payload: error
});

export const RECIEVING_COUNTRIES_ON_LOAD = 'productMngt/get_recieving_countries';
export const getRecievingCountries = () => ({
  type: RECIEVING_COUNTRIES_ON_LOAD
});

export const RECIEVING_COUNTRIES_ON_SUCCESS = 'productMngt/recieving_countries_on_success';
export const recievingCountriesOnSuccess = (data) => ({
  type: RECIEVING_COUNTRIES_ON_SUCCESS,
  payload: data
});

export const RECIEVING_COUNTRIES_ON_FAILED = 'productMngt/recieving_countries_on_failed';
export const recievingCountriesOnFailed = (error) => ({
  type: RECIEVING_COUNTRIES_ON_FAILED,
  payload: error
});

export const UPDATE_TIER_FEE = 'productMngt/update_tier_fee';
export const updateTierFee = (data) => ({
  type: UPDATE_TIER_FEE,
  payload: data
});

export const UPDATE_TIER_FEE_ON_SUCCESS = 'productMngt/update_tier_fee_on_success';
export const updateTierFeeOnSuccess = (data) => ({
  type: UPDATE_TIER_FEE_ON_SUCCESS,
  payload: data
});

export const UPDATE_TIER_FEE_ON_FAILED = 'productMngt/update_tier_fee_on_failed';
export const updateTierFeeOnFailed = (error) => ({
  type: UPDATE_TIER_FEE_ON_FAILED,
  payload: error
});

export const CORRIDOR_REF_ON_LOAD = 'productMngt/get_corridor_reference';
export const getCorridorReferencesById = (serviceId) => ({
  type: CORRIDOR_REF_ON_LOAD,
  payload: serviceId
});

export const CORRIDOR_REF_ON_SUCCESS = 'productMngt/corridor_reference_on_success';
export const corridorReferencesOnSuccess = (data) => ({
  type: CORRIDOR_REF_ON_SUCCESS,
  payload: data
});

export const CORRIDOR_REF_ON_FAILED = 'productMngt/corridor_reference_on_failed';
export const corridorReferencesOnFailed = (error) => ({
  type: CORRIDOR_REF_ON_FAILED,
  payload: error
});

export const PRODUCT_DETAIL_ON_RESET = 'productMngt/detail_on_reset';
export const productDetailOnReset = () => ({
  type: PRODUCT_DETAIL_ON_RESET
});

export const PRODUCT_UPDATE_ON_LOAD = 'productMngt/update_on_load';
export const updateProduct = (data) => ({
  type: PRODUCT_UPDATE_ON_LOAD,
  payload: data
});

export const PRODUCT_UPDATE_ON_SUCCESS = 'productMngt/update_on_success';
export const updateProductOnSuccess = (data) => ({
  type: PRODUCT_UPDATE_ON_SUCCESS,
  payload: data
});

export const PRODUCT_UPDATE_ON_FAILED = 'productMngt/update_on_failed';
export const updateProductOnFailed = (error) => ({
  type: PRODUCT_UPDATE_ON_FAILED,
  payload: error
});

// Update Selected hub by country and serviceType
export const REQUEST_SELECTED_HUB_ON_LOAD = 'request/product/select_hub_on_load';
export const requestSelectedHub = (data) => ({
  type: REQUEST_SELECTED_HUB_ON_LOAD,
  payload: data
});

export const REQUEST_SELECTED_HUB_ON_SUCCESS = 'request/product/select_hub_on_success';
export const requestSelectedHubOnSuccess = (data) => ({
  type: REQUEST_SELECTED_HUB_ON_SUCCESS,
  payload: data
});

export const REQUEST_SELECTED_HUB_ON_FAILED = 'request/product/select_hub_on_failed';
export const requestSelectedHubOnFailed = (error) => ({
  type: REQUEST_SELECTED_HUB_ON_FAILED,
  payload: error
});

export const REQUEST_SELECTED_HUB_ON_RESET = 'request/product/select_hub_on_reset';
export const requestSelectedHubOnReset = (error) => ({
  type: REQUEST_SELECTED_HUB_ON_RESET
});

// Corridor--

export const ADD_NEWBANK_TO_CORRIDORS = 'productMngt/add_new_bank_to_corridors';
export const addNewBankToCorridors = data => ({
  type: ADD_NEWBANK_TO_CORRIDORS,
  payload: data
});

export const ADD_NEWBANK_TO_CORRIDORS_SUCCESS = 'productMngt/add_new_bank_to_corridors_success';
export const addNewBankToCorridorsSuccess = data => ({
  type: ADD_NEWBANK_TO_CORRIDORS_SUCCESS,
  payload: data
});

export const ADD_NEWBANK_TO_CORRIDOR = 'productMngt/add_new_bank_to_corridor';
export const addNewBankToCorridor = data => ({
  type: ADD_NEWBANK_TO_CORRIDOR,
  payload: data
});

export const ADD_NEWBANK_TO_CORRIDOR_SUCCESS = 'productMngt/add_new_bank_to_corridor_success';
export const addNewBankToCorridorSuccess = data => ({
  type: ADD_NEWBANK_TO_CORRIDOR_SUCCESS,
  payload: data
});
 
export const UPDATE_BANK_IN_CORRIDOR = 'productMngt/update_bank_in_corridor';
export const updateBankInCorridor = data => ({
  type: UPDATE_BANK_IN_CORRIDOR,
  payload: data
});

export const UPDATE_BANK_IN_CORRIDOR_SUCCESS = 'productMngt/update_bank_in_corridor_success';
export const updateBankInCorridorSuccess = data => ({
  type: UPDATE_BANK_IN_CORRIDOR_SUCCESS,
  payload: data
});

//----- issuer ML -- remove add & addsuccess after confirmation of transactional
export const ADD_NEWBANK_TO_ISSUERML = 'productMngt/add_new_bank_to_issuerml';
export const addNewBankToIssuerML = data => ({
  type: ADD_NEWBANK_TO_ISSUERML,
  payload: data
});

export const ADD_NEWBANK_TO_ISSUERML_SUCCESS = 'productMngt/add_new_bank_to_issuerml_success';
export const addNewBankToIssuerMLSuccess = data => ({
  type: ADD_NEWBANK_TO_ISSUERML_SUCCESS,
  payload: data
});
 
export const UPDATE_BANK_IN_ISSUERML = 'productMngt/update_bank_in_issuerml';
export const updateBankInIssuerML = data => ({
  type: UPDATE_BANK_IN_ISSUERML,
  payload: data
});

export const UPDATE_BANK_IN_ISSUERML_SUCCESS = 'productMngt/update_bank_in_issuerml_success';
export const updateBankInIssuerMLSuccess = data => ({
  type: UPDATE_BANK_IN_ISSUERML_SUCCESS,
  payload: data
});
//---- issuer ML fetch

export const ISSUER_ML_FETCH = 'productMngt/issuer_ml_data_fetch';
export const issuerMLDataFetch = data => ({
  type: ISSUER_ML_FETCH,
  payload: data
});

export const ISSUER_ML_FETCH_SUCCESS = 'productMngt/issuer_ml_data_fetch_success';
export const issuerMLDataFetchSuccess = data => ({
  type: ISSUER_ML_FETCH_SUCCESS,
  payload: data
});

export const ISSUER_ML_DATA_RESET = 'productMngt/issuer_ml_data_reset';
export const issuerMLDataReset = () => ({
  type: ISSUER_ML_DATA_RESET
});

//---- issuer fetch

export const ISSUER_FETCH = 'productMngt/issuer_data_fetch';
export const issuerDataFetch = data => ({
  type: ISSUER_FETCH,
  payload: data
});

export const ISSUER_FETCH_SUCCESS = 'productMngt/issuer_data_fetch_success';
export const issuerDataFetchSuccess = data => ({
  type: ISSUER_FETCH_SUCCESS,
  payload: data
});

export const ISSUER_DATA_RESET = 'productMngt/issuer_data_reset';
export const issuerDataReset = () => ({
  type: ISSUER_DATA_RESET
});

export const SUBMIT_TIER_FEE_REQUEST = 'productMngt/submit_tier_fee_request';
export const submitTierFeeRequest = (payload) => ({
  type: SUBMIT_TIER_FEE_REQUEST,
  payload
});

export const SUBMIT_TIER_FEE_REQUEST_SUCCESS = 'productMngt/submit_tier_fee_request_success';
export const submitTierFeeRequestSuccess = (data) => ({
  type: SUBMIT_TIER_FEE_REQUEST_SUCCESS,
  payload: data
});

export const FETCH_REQUEST_FLOW = 'productMngt/fetch_request_flow';
export const fetchRequestFlow = () => ({
  type: FETCH_REQUEST_FLOW
});

export const FETCH_REQUEST_FLOW_SUCCESS = 'productMngt/fetch_request_flow_success';
export const fetchRequestFlowSuccess = (data) => ({
  type: FETCH_REQUEST_FLOW_SUCCESS,
  payload: data
});

export const FETCH_ISSUERS_BY_COUNTRY_STATUS = 'productMngt/fetch_issuers_by_country_status';
export const fetchIssuersByCountryStatus = (data) => ({
  type: FETCH_ISSUERS_BY_COUNTRY_STATUS,
  payload: data
});

export const FETCH_ISSUERS_BY_COUNTRY_STATUS_SUCCESS = 'productMngt/fetch_issuers_by_country_status_success';
export const fetchIssuersByCountryStatusSuccess = (data) => ({
  type: FETCH_ISSUERS_BY_COUNTRY_STATUS_SUCCESS,
  payload: data
});

export const FETCH_ISSUERS_BY_COUNTRY_STATUS_FAILED = 'productMngt/fetch_issuers_by_country_status_failed';
export const fetchIssuersByCountryStatusFailed = (error) => ({
  type: FETCH_ISSUERS_BY_COUNTRY_STATUS_FAILED,
  payload: error
});

export const REQUEST_ISSUERS_BY_COUNTRY_STATUS = 'productMngt/request_issuers_by_country_status';
export const requestIssuersByCountryStatus = (data) => ({
  type: REQUEST_ISSUERS_BY_COUNTRY_STATUS,
  payload: data
});

export const REQUEST_ISSUERS_BY_COUNTRY_STATUS_SUCCESS = 'productMngt/request_issuers_by_country_status_success';
export const requestIssuersByCountryStatusSuccess = (data) => ({
  type: REQUEST_ISSUERS_BY_COUNTRY_STATUS_SUCCESS,
  payload: data
});

export const REQUEST_ISSUERS_BY_COUNTRY_STATUS_FAILED = 'productMngt/request_issuers_by_country_status_failed';
export const requestIssuersByCountryStatusFailed = (data) => ({
  type: REQUEST_ISSUERS_BY_COUNTRY_STATUS_FAILED,
  payload: data
});

export const FETCH_WALLETS_BY_COUNTRY_STATUS = 'productMngt/fetch_wallets_by_country_status';
export const fetchWalletsByCountryStatus = (data) => ({
  type: FETCH_WALLETS_BY_COUNTRY_STATUS,
  payload: data
});

export const FETCH_WALLETS_BY_COUNTRY_STATUS_SUCCESS = 'productMngt/fetch_wallets_by_country_status_success';
export const fetchWalletsByCountryStatusSuccess = (data) => ({
  type: FETCH_WALLETS_BY_COUNTRY_STATUS_SUCCESS,
  payload: data
});

export const FETCH_WALLETS_BY_COUNTRY_STATUS_FAILED = 'productMngt/fetch_wallets_by_country_status_failed';
export const fetchWalletsByCountryStatusFailed = (error) => ({
  type: FETCH_WALLETS_BY_COUNTRY_STATUS_FAILED,
  payload: error
});

export const REQUEST_WALLETS_BY_COUNTRY_STATUS = 'productMngt/request_wallets_by_country_status';
export const requestWalletsByCountryStatus = (data) => ({
  type: REQUEST_WALLETS_BY_COUNTRY_STATUS,
  payload: data
});

export const REQUEST_WALLETS_BY_COUNTRY_STATUS_SUCCESS = 'productMngt/request_wallets_by_country_status_success';
export const requestWalletsByCountryStatusSuccess = (data) => ({
  type: REQUEST_WALLETS_BY_COUNTRY_STATUS_SUCCESS,
  payload: data
});

export const REQUEST_WALLETS_BY_COUNTRY_STATUS_FAILED = 'productMngt/request_wallets_by_country_status_failed';
export const requestWalletsByCountryStatusFailed = (data) => ({
  type: REQUEST_WALLETS_BY_COUNTRY_STATUS_FAILED,
  payload: data
});

export const LAST_MESSAGE_RESET= 'productMngt/last_message_reset';
export const lastMessageReset = () => ({
  type: LAST_MESSAGE_RESET
});